import { ConservationMethodology } from '@/api/rest/resources/conservation';
import { EcologicalIntegrityPage as EcologicalIntegrityPageBU } from '@/pages/shared/projects/pages/project/pages/conservation/BU/pages/ecological-integrity/ecological-integrity.page';
import { HabitatIntactnessPage as HabitatIntactnessPageBU } from '@/pages/shared/projects/pages/project/pages/conservation/BU/pages/habitat-intactness/habitat-intactness.page';
import { IndicatorSpeciesPage } from '@/pages/shared/projects/pages/project/pages/conservation/BU/pages/indicator-species/indicator-species.page';
import { useProject } from '@/pages/shared/projects/pages/project/pages/conservation/shared/hooks/useProject';
import { EcologicalIntegrityPage as EcologicalIntegrityPageVNU } from '@/pages/shared/projects/pages/project/pages/conservation/VNU/pages/ecological-integrity/ecological-integrity.page';
import { FloraAndFaunaPage } from '@/pages/shared/projects/pages/project/pages/conservation/VNU/pages/flora-and-fauna/flora-and-fauna.page';
import { HabitatIntactnessPage as HabitatIntactnessPageVNU } from '@/pages/shared/projects/pages/project/pages/conservation/VNU/pages/habitat-intactness/habitat-intactness.page';

const PROJECT_NOT_FOUND_ERROR = 'Conservation project not found';

export const HabitatIntactnessPages = () => {
  const project = useProject();

  if (!project) {
    throw new Error(PROJECT_NOT_FOUND_ERROR);
  }

  if (project.natureUnitVariant === ConservationMethodology.vnu) {
    return <HabitatIntactnessPageVNU />;
  }

  return <HabitatIntactnessPageBU />;
};

export const IndicatorSpeciesPages = () => {
  const project = useProject();

  if (!project) {
    throw new Error(PROJECT_NOT_FOUND_ERROR);
  }

  if (project.natureUnitVariant === ConservationMethodology.vnu) {
    return <FloraAndFaunaPage />;
  }

  return <IndicatorSpeciesPage />;
};

export const EcologicalIntegrityPages = () => {
  const project = useProject();

  if (!project) {
    throw new Error(PROJECT_NOT_FOUND_ERROR);
  }

  if (project.natureUnitVariant === ConservationMethodology.vnu) {
    return <EcologicalIntegrityPageVNU />;
  }

  return <EcologicalIntegrityPageBU />;
};
